import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeId, tableId, sessionId, getItemCount } = useCart();
  const cartCount = getItemCount();

  const isMenu = location.pathname.startsWith('/table/');
  const isCart = location.pathname.startsWith('/cart/');
  const isOrders = location.pathname.startsWith('/orders/');
  const isHistory = location.pathname.startsWith('/history/');
  const isPayment = location.pathname.startsWith('/payment/');

  return (
    <div className="bottom-nav">
      <button
        className={`bottom-nav-item ${isMenu ? 'active' : ''}`}
        onClick={() => storeId && tableId && navigate(`/table/${storeId}/${tableId}`)}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        <span>메뉴</span>
      </button>

      <button
        className={`bottom-nav-item ${isCart ? 'active' : ''}`}
        onClick={() => storeId && tableId && navigate(`/cart/${storeId}/${tableId}`)}
        style={{ position: 'relative' }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <circle cx="9" cy="21" r="1"/>
          <circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
        </svg>
        {cartCount > 0 && (
          <span className="nav-badge cart-badge-pop" key={cartCount}>{cartCount}</span>
        )}
        <span>장바구니</span>
      </button>

      <button
        className={`bottom-nav-item ${isOrders || isHistory || isPayment ? 'active' : ''}`}
        onClick={() => {
          if (sessionId && storeId && tableId) {
            navigate(`/history/${storeId}/${tableId}`);
          } else if (sessionId) {
            navigate(`/orders/${sessionId}`);
          }
        }}
        disabled={!sessionId && !storeId}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="8" y1="6" x2="21" y2="6"/>
          <line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/>
          <circle cx="3" cy="6" r="1" fill="currentColor"/>
          <circle cx="3" cy="12" r="1" fill="currentColor"/>
          <circle cx="3" cy="18" r="1" fill="currentColor"/>
        </svg>
        <span>주문내역</span>
      </button>
    </div>
  );
}
